import { Injectable } from '@angular/core';

import { IBuildBetResponse } from '@frontend/oxygen/bet-history-utils';
import { IBetslipData } from '@frontend/oxygen/betslip-utils';
import { IBetBetslip, IBetError, ILeg, ILegList } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { Bet } from '../bet/bet';
import { BetErrorService } from '../betError/bet-error.service';
import { BetFactoryService } from '../betFactory/bet-factory.service';
import { el } from '../json-element';
import { LegFactoryService } from '../legFactory/leg-factory.service';
import { SportsLeg } from '../sportsLeg/sports-leg';

// @Injectable({ providedIn: 'root' })
@Injectable({ providedIn: 'root' })
export class BsDocService {
    action: string;
    docId: string = '';

    constructor(
        public betFactoryService: BetFactoryService,
        private legFactoryService: LegFactoryService,
        private betErrorService: BetErrorService,
    ) {}

    el(...args: SportsLeg[] | any) {
        // @ts-ignore
        return el(...args);
    }

    buildRequest(data: SportsLeg[] | any) {
        return el(this.action, this.content(data));
    }

    setResponse(response: IBuildBetResponse | any): IBetslipData {
        if (Array.isArray(response) && response[0].isLotto) {
            const lottoBets: Bet[] = this.betFactoryService.constructBets(response, [], []);
            return { bets: lottoBets! };
        }
        const legs: ILegList = this.legFactoryService.parseLegs(<ILeg[]>response.legs);
        const betErrors = _.filter(_.pluck(response.bets, 'betErrors'), (betError: any) => {
            return !!betError && betError.code;
        });
        const errs: IBetError[] = this.betErrorService.parseErrors(betErrors || []) as IBetError[];
        const bets: Bet[] = this.betFactoryService.constructBets(response.bets || response.bet || [], legs, errs as IBetError[]);
        const betOffers = response.betOfferRef || [];
        return { legs, bets: bets as IBetBetslip[], errs, betOffers };
    }

    content(data: any): any {
        // abstract function
        return {};
    }
}
